<template>
  <div class="memberIndex">
    <div class="right">
      <div class="currentMenu"></div>
      <div class="right_content">
        <div class="change_inform">
          <div class="title">我的待提交报价</div>
          <el-button class="btn_2" @click="fnCancel">取消报价</el-button>
          <el-button class="btn_2" @click="fnBatchEdit">提交报价</el-button>
        </div>
        <div class="right_out">
          <div style="padding: 5px; margin: 10px">
            <span>设备名称</span>
            <el-input type="text" class="input" v-model="Query.InstrumentName" size="mini"></el-input>
            <el-button id="search" @click="fnGetData">搜索</el-button>
          </div>
          <el-table class="table_wrap1" :data="detailList" style="width: 100%" :height="760" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="SysCode" label="设备编号"></el-table-column>
            <el-table-column prop="InstrumentName" label="设备名称"></el-table-column>
            <el-table-column prop="Count" label="询价数量">
              <template slot-scope="scope">
                <span>{{ scope.row.Count }}({{ scope.row.Unit }})</span>
              </template>
            </el-table-column>
            <el-table-column prop="Brand" label="品牌要求"></el-table-column>
            <el-table-column prop="Specification" label="规格型号"></el-table-column>
            <el-table-column prop="CountDown" label="剩余时间"></el-table-column>
            <el-table-column prop="TotalPrice" label="我的报价"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selected: [],
      Query: {
        InstrumentName: ''
      },
      detailList: []
    }
  },
  mounted() {
    this.fnGetData()
    window.addEventListener('storage', (e) => {
      let that = this
      if (e.key == 'commitOffer') {
        localStorage.removeItem('commitOffer')
        this.fnGetData()
      }
    })
  },
  methods: {
    fnGetData() {
      let config = {
        params: {
          Query: JSON.stringify(this.Query)
        }
      }
      this.getRequest('/InQuiryPrice/CommitingOfferList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.detailList = res.data.detailList
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleSelectionChange(val) {
      this.selected = val
      console.log(this.selected)
    },

    fnBatchEdit() {
      if (this.selected.length == 0) {
        this.$message.error('请勾选设备')
        return
      }
      let data = []
      this.selected.forEach(function (obj) {
        console.log(obj)
        data.push(obj.DetailId)
      })

      let routerData = this.$router.resolve({
        name: 'EditOffers',
        query: { detailIds: data.join(',') }
      })
      window.open(routerData.href, '_blank')
    },
    fnCancel() {
      if (this.selected.length == 0) {
        this.$message.error('请勾选设备')
        return
      }
      let data = []
      this.selected.forEach(function (obj) {
        console.log(obj)
        data.push(obj.DetailId)
      })
      let loginToken = window.localStorage.getItem('loginToken')
      this.postRequest('/InQuiryPrice/CancelCommit', { detailIds: data.join(','), loginToken: loginToken }).then((res) => {
        if (res.data.errcode == 0) {
          this.$message.success('操作成功')
          this.fnGetData()
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.memberIndex {
  display: flex;
  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;
    .logined_wrap {
      padding: 10px;
      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }
      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }
      .img {
        margin-left: 30px;
      }
      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;
          .labell {
            font-weight: bold;
          }
          img {
            margin-right: 5px;
          }
        }
      }
    }
  }
  .right {
    background: #e4e4e4;
    flex: 1;
    padding: 0 0 10px 0;
    .right_out {
      width: 98%;
      margin: 0 auto;
    }

    .currentMenu {
      margin: 16px 5px;
    }
    .right_content {
      margin: 0 10px;
      // height: 93%;
      background: #f7f7f7;
      padding-bottom: 10px;
    }
    #search {
      width: 120px;
    }
    .input {
      width: 180px;
      margin-right: 50px;
      margin-left: 5px;
    }
    ::v-deep.el-input--mini .el-input__inner {
      height: 28px;
      line-height: 28px;
    }
    .btn_wrap {
      .btn {
        margin: auto;
        color: #6a96bc;
        border: 1px solid #6a96bc;
        border-radius: 5px;
        padding: 2px 18px;
      }
    }
  }
}
.btn_2 {
  float: right;
  border-radius: 6px;
  margin-top: 4px;
  margin-right: 5px;
}
</style>
